/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Go_To_WorkflowsInputs */



/**
* | output |
* | --- |
* | "Go to your workflows" |
*
* @param {Marketing_Go_To_WorkflowsInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const marketing_go_to_workflows = /** @type {((inputs?: Marketing_Go_To_WorkflowsInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Go_To_WorkflowsInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Go to your workflows")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Gå till dina arbetsflöden")
	return /** @type {LocalizedString} */ ("Gå til arbeidsflytene dine")
});